export type OGImageConfig = {
  isCustom: boolean
  title?: string
  description?: string
  image?: string
  icon?: string
  width?: number
  height?: number
  backgroundColor?: string
  titleColor?: string
  descriptionColor?: string
  fontSize?: {
    title: number
    description: number
  }
  borderRadius?: number
}

export type OGMetaTags = {
  title: string
  description: string
  image: string
  url: string
  type?: 'website' | 'article' | 'profile'
  twitterHandle?: string
}

export const defaultCustomOGConfig: OGImageConfig = {
  isCustom: true,
  title: 'Imagine App',
  description: 'Build something real',
  width: 1200,
  height: 630,
  backgroundColor: '#ffffff',
  titleColor: '#000000',
  descriptionColor: '#666666',
  fontSize: {
    title: 60,
    description: 30,
  },
  borderRadius: 12,
}

export function generateOGImageUrl(
  config: Partial<OGImageConfig>,
  baseUrl: string,
): string {
  const normalizedBase = baseUrl.replace(/\/$/, '')
  const defaultImageUrl = `${normalizedBase}/default-og-image.png`

  if (!config.isCustom) {
    return defaultImageUrl
  }

  return defaultImageUrl
}

export function createOGMetaTags(config: OGMetaTags) {
  const {
    title,
    description,
    image,
    url,
    type = 'website',
    twitterHandle,
  } = config

  return {
    meta: [
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:image', content: image },
      { property: 'og:url', content: url },
      { property: 'og:type', content: type },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: image },
      ...(twitterHandle
        ? [{ name: 'twitter:creator', content: twitterHandle }]
        : []),
      { name: 'description', content: description },
    ],
  }
}
